import type { SVGProps } from 'react';

export const StarFill = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="m11.693 17.22-3.89 2.345a.72.72 0 0 1-.436.107.791.791 0 0 1-.395-.147.84.84 0 0 1-.273-.332.649.649 0 0 1-.031-.453l1.033-4.417-3.435-2.973a.736.736 0 0 1-.245-.387.702.702 0 0 1 .028-.428.845.845 0 0 1 .232-.34.808.808 0 0 1 .416-.172l4.532-.396 1.76-4.171a.678.678 0 0 1 .291-.345.82.82 0 0 1 .825 0c.13.075.228.19.292.345l1.76 4.171 4.532.396a.807.807 0 0 1 .416.172c.1.088.178.201.232.34a.702.702 0 0 1 .028.428.736.736 0 0 1-.245.387l-3.435 2.973 1.033 4.417a.649.649 0 0 1-.03.453.841.841 0 0 1-.274.332.791.791 0 0 1-.395.147.72.72 0 0 1-.436-.107l-3.89-2.346Z" />
    </svg>
  );
};
